module.exports = __webpack_public_path__ + "static/img/ad-bar1.a640174f.png";